import React, { ComponentType, FunctionComponent } from "react";

export interface Props {
  component: ComponentType<unknown>;
  componentProps?: Record<string, unknown>;
}

export const NoRouteMatch: FunctionComponent<Props> = ({
  component: RoutedComponent,
  componentProps = {},
}) => <RoutedComponent {...componentProps} />;

export default NoRouteMatch;
